require('./style.less');

var _ = require('underscore'),
    $ = require('jquery'),
    fvChannel = require('glRadio').channel('FV'),

    PgModeImgWr = require('../../pgMode/pagePgMode'),
    TextOverlay = require('../textOverlay/textOverlay'),
    TextGridModel = require('../TextGridModel'),
    TextPageActionDropdown = require('../textPageDropdown/view');

require('CRE');


/**
 * TODO: this whole process should be cleaned up, especially with new rotation method and given other text page tickets
 * Continue fetching page text on demand due to bottleneck loading document with many pages
 * ( vs send in original doc info response ).
 * - should have at least a wrapper around the paper and overlay with the max dimensions for positioning
 * childViews: -- want to make base page a babysitter view and then add these children for cleanup
 *  - textOverlay
 */

var instVars = {

    hasImageOverlay: 0, // cache

    // (only applicable to when 'drawing'; always start disabled, enable only after canvas is put on DOM )
    // means the z-index of the text view is above the canvas (when in canvas edit mode)
    selectTextMode: 0,

    showImgOverlay: null,
    showGreenbar: null,

    $dfdTextFetched: null, // deferreds must be set anew each time (extend is copying by ref onto the PROTOTYPE)
    $dfdImageAppended: null,

    imgActualDims: null, //(only set if has img overlay)

    wasDestroyed: 0 // DVBC-1728: flag the the view was destroyed

};


module.exports = PgModeImgWr.extend({

    PageActionsDropDownView: TextPageActionDropdown,

    // Note: called twice due to Marionette _ensureElement constructor (and on serialize data); doesn't hurt:
    // Just make sure don't change the prototype (why interm. step)
    className: function() {
        var c = PgModeImgWr.prototype.className;
        return c += ' FV-pgCold';
    },

    initialize: function() {

        PgModeImgWr.prototype.initialize.apply(this, arguments);

        var localStorage = fvChannel.request('localStorage');

        _.extend( this, instVars, {

            $dfdTextFetched: $.Deferred(),
            $dfdImageAppended: $.Deferred(),

            hasImageOverlay: this.model.hasImageOverlay(),
            showImgOverlay: localStorage.getShowOverlays(),
            showGreenbar: localStorage.getShowGreenbar()

        } );


        if ( this.hasImageOverlay ) {

            var overlayImgProps = this.model.get('overlay').imageProperties;

            this.imgActualDims =  {
                width: overlayImgProps.width / overlayImgProps.originalHDPI * 96,
                height: overlayImgProps.height / overlayImgProps.originalVDPI * 96
            };

        }

        var self = this;

        // Take over page workflow here
        $.when( this.$dfdTextFetched, this.$dfdImageAppended ).done( function() {

            // DVBC-1728- if the view was destroyed from changing the page prior to
            // completion of the dfd's, abort; otherwise runtime errors will ensure trying
            // to append things to a DOM that no longer exists.
            if ( self.wasDestroyed ) {
                return;
            }

            /**
             * Stop spinner when no image overlay
             * ( we could actually call regardless because the event will only be listened to once, and skipped the 2nd time if an overlay )
             *
             */
            if ( !self.hasImageOverlay ) {
                self.model.set( 'isLoaded', true );
            }

            self._createTextOverlayView.call( self );


            // 'Continue': create canvas if necessary and reveal as for regular page with just an image
            PgModeImgWr.prototype.onAfterImageAppend.call( self );

        });


        if (!this.hasImageOverlay) {
            this.$dfdImageAppended.resolveWith( this );
        }


    },

    /**
     * Combo the image request (if there is an overlay), with the text request.
     * For the former, onAfterImageAppend is overwritten: proceeding to it require the text as well.
     * Failure: of either cre req or text req after successful cre req
     * Now skip the getting the text and creating the grid model if it was already fetched.
     */
    requestImg: function() {

        this.hasImageOverlay &&
            PgModeImgWr.prototype.requestImg.call( this, this.model.get('overlay').address );

        if ( this.model.get('textGridModel') ) {
            this.$dfdTextFetched.resolveWith( this );
            return;

        }

        this.doTextRequest()
            .done( function( text ) {
                var textGridModel =  new TextGridModel( text, this.model.get('overlay') );

                // Cache on the document mode page model ( it would get cleared from the page model )
                var pgModel =  this.vChannel.request( 'getPageModelFromNumber', this.model.get('number') ); // this is different than this.model
                pgModel.setTextGridModel( textGridModel );

                // And the first time through store on the full page model -- subsequent times will be cloned.
                this.model.setTextGridModel( textGridModel );

                this.$dfdTextFetched.resolveWith( this );

            })
            .fail( function( shortMessage, detailedMsg ) {
                // Note: the top $dfd won't be resolved.
                this.model.trigger( 'imgLoadError', shortMessage + ': ' + detailedMsg );

            });

    },

    /* ( override -- don't do if no image overlay ) */
    _appendImageView: function() {

        if ( !this.hasImageOverlay ) {
            return;
        }

        PgModeImgWr.prototype._appendImageView.apply( this, arguments );

    },

    /**
     * Must do here otherwise reveal won't work if option it to not show.
     * Leave invisible to take up space (still need to measure size) and make opaque for visual effect
     */
    onBeforeImageAppend: function() {

        PgModeImgWr.prototype.onBeforeImageAppend.apply(this, arguments);
        !this.showImgOverlay && this.imgView.$el.addClass('noOpacity');

    },
    /**
     * Only applicable is there is an overlay image.
     * Override 'base' to resolve the $dfdImage appended, taking over regular page
     * workflow to account for requesting the text from the CRE.
     */
    onAfterImageAppend: function() {

        // This could be in template if want sep template here ... that could clean up a bunch of stuff
        // Unsure exactly what this was for or if still necessary
        this.imgView.$el.wrap( $('<div class="coldImgOverlayWr">') );

        // Must scale prior to creation of canvas -- and do b/f reveal anyway
        // Unknowns dims does this after setting the dims as well
        this.updateViewPort();

        this.$dfdImageAppended.resolveWith(this);

    },

    /**
     *
     * Toggle enabled the text-selection menu-item -- feature only applies if there is a canvas on the page
     * - (selecting text over the canvas)
     * - this will cover the case of when a canvas is created on page load & when a new one is created by creating a new drawable note
     * Don't disable the menu item after it's already been enabled
     * - (the canvas is not deleted if there are no shapes; still want to be able to select text)
     * -  improvement would be to set this back already
     * TODO ... on close of canvas without shapes, set back its z-index, maybe can get from is page has drawable notes / shapes ?
     * it should do the right thing, if no shapes, always put it in select text mode
     */
    _createPageActionDropDown: function() {

        PgModeImgWr.prototype._createPageActionDropDown.apply(this, arguments);

        /**
         * Very hacky way of positioning the dropdown menu outside the page inner wrapper
         * Quick fix in lieu of creating another template.
         * Can't do with page css b/c no longer in the page (its in the container) -- may be able to change this now ....
         */
        this.pageDDView.options.el.css({
            right: '5px'
        }).insertAfter(this.$el);

        /**
         * DVBC-1141 -- notes:
         * Like the old buttons, not great b/c if page scale is small, will not be positioned relative to the page -- its now positioned to the container
         * For fit width, it's ok looking
         * Real answer is different markup where the page is not the placeholder for the loading image -- so can position accordingly, but will likely break existing model
         * AND NOW ITS VIEWABLE AND OUT OF THE WAY OF THE OTHER BUTTONS
         * And it's now viewable out of the way of the old buttons
         */
    },
    _getActionDropDownOptions: function() {

        return _.extend( {}, PgModeImgWr.prototype._getActionDropDownOptions.apply(this, arguments), {
                parent: this, //prob better mediated later on ... now imple. like had done with the old toggle buttons ... see the callbacks below
                hasImageOverlay: this.hasImageOverlay //I think also on model
            },
            // values are what to set on the first render --
            // 'selectTextMode' not needed -- on render it always start false
            _.pick( this, 'showImgOverlay', 'showGreenbar')
        );

    },

    /**
     * Toggle button callbacks.
     * Note: only applicable when in 'canvas editing mode'
     * Swap the z-index of the canvas and text views -- selectTextMode is when the text is above the canvas
     */
    onToggleTextSelection: function() {
        this.selectTextMode = !this.selectTextMode; // not sure if variable is still what is wanted here
        this.$el.toggleClass('canvas-edit-mode-select-text', this.selectTextMode);
    },

    onToggleOverlayImg: function() {
        this.showImgOverlay = !this.showImgOverlay;
        fvChannel.request('localStorage').setShowOverlays( this.showImgOverlay ? 1 : 0 );
        this.imgView.$el.toggleClass('noOpacity', !this.showImgOverlay, 400); // Allow to take up space!
    },

    onToggleGreenBar: function() {
        this.showGreenbar = !this.showGreenbar;
        fvChannel.request('localStorage').setShowGreenbar( this.showGreenbar ? 1 : 0 );
        this.textOverlay.toggleGreenBar(); // mediate?
    },
    /*
    * Actually 2 requests:
    * - the render request from the CRE then,
    * - the text to render from the 'inlineUrl' returned from the first.
    * The text is what is really desired (along with deferred).
    * Now only called if not already fetched.
    * onStart:
    * - onStart as base page ( kick off 'loading state' with spinner ) -- $.noop
    * - if there's an image overlay, the event can only be kicked off once ( see .off in base page ),
    * - so in general, error handling works for pages with and without overlays ( tested )
    * */
    doTextRequest: function() {

        var fvSettings = fvChannel.request('settings'),
            self = this,
            model = this.model;

        return $.Deferred(function($dfd) {

            $.fn.creRequest( _.extend( {}, model.getTextOverlayRenderRequest(), {

                onStart: _.bind( model.set, model, {'wasRequested': true}),

                onComplete: function(data) {

                    /* Get the overlay text from the resulting data */
                    $.ajax({
                        url: data.downloadUrl,
                        type: 'GET',
                        dataType: 'text'
                    }).done( function(text) {
                        $dfd.resolveWith(self, [text]);

                    }).fail( function( jqXHR ) {
                        $dfd.rejectWith( self, ['Error Retrieving Overlay Text', $.fn.ajaxErrorMessage( jqXHR ) ] );
                    });

                },
                onError: function(errMsg) {
                    $dfd.rejectWith( self, ['Error Requesting Overlay From CRE', errMsg] );
                },
                fileName: model.getPageName( undefined, 1 ),
                CRE_ROOT: fvSettings.getCRERoot(),
                POLL_FREQ: fvSettings.crePollInterval
            }));

        }).promise();

    },

    _createTextOverlayView: function( ) {

        var pageDimensionsChanged = false;

        if ( !this.hasImageOverlay ) {
            pageDimensionsChanged = this._adjustPageDimsBasedOnActualTextDims();
        }

        this.textOverlay = new TextOverlay({
            parent: this,
            model: this.model,
            textGridModel: this.model.getTextGridModel()
        });

        var overlay = this.model.get('overlay');


        /**
         * For pages with image overlays without dimensions -- apply the CRE's logic of setting the page size to
         * that derived from the text (CRE-260; if there's no overlay, FDD's adjustment logic would always work,
         * since pages without dimensions would be adjusted ).
         * Do this after the first conditional -- until refactor, utilize textOverlay to get the actual dimensions.
         */
        if ( this.hasImageOverlay ) {

            if (  overlay.paperWidth === 0 || overlay.paperHeight === 0 ) {

                var actualTextDimensions = this.model.getTextGridModel().actualDimensions( );

                this.model.set({
                    width: actualTextDimensions.width,
                    height: actualTextDimensions.height
                }, {silent: true});

                pageDimensionsChanged = true;

            }
        }

        // Order: for now put on the bottom below the image (which is under the canvas)
        // !! append to DOM first, prior to render, (or else widths will be 0)
        this.ui.transformedWr.append( this.textOverlay.el );

        /**
         * DVBC-1168 -- if the width/height are changed, need to reset the scale
         * Otherwise, the calc's done pre-fetching the text will be off (for derived scale types).
         * This must be done prior to rendering the text overlay view, which incorporates the scale value.
         * What should be do instead is render the view at a scale of 1 and then update the viewport instead ...
         * REFACTOR THIS MESS
         */
        if ( pageDimensionsChanged ) {
            this.vChannel.command('setScale');
        }

        this.textOverlay.render( this.scale.getScaleValue(), this.showGreenbar );

        // this required now to update different dimensions like page .... rewrite inevitable )
        // what s/b done is render the overlay without the scale value -- then call update viewport ( which would scale it )
        this.updateViewPort();

    },

    /**
     * Note: only applicable to pages without image overlays.
     * Returns true/false if dimensions are changed
     */
    _adjustPageDimsBasedOnActualTextDims: function() {

        var m = this.model,
            o = m.get('overlay'),
            bPageDimsChanged = false,
            textGridModel = m.getTextGridModel();

        var derivedWidth = textGridModel.maxCols / o.cpi,
            derivedHeight = textGridModel.nRows / o.lpi,
            derivedWidthIncludingOffset = derivedWidth + o.xTextOffset,
            derivedHeightIncludingOffset = derivedHeight + o.yTextOffset;

        // If the actual size of the grid is greater than the size of the paper (the text extends beyond the page dimension)
        if ( (derivedWidthIncludingOffset > o.paperWidth) || (derivedHeightIncludingOffset > o.paperHeight ) )  {

            var derivedHtIsLessThanWidth = derivedHeightIncludingOffset < derivedWidthIncludingOffset,
                paperHtIsLessThanWidth = o.paperHeight < o.paperWidth;

            // if the aspect ratio of the text is different from the aspect ratio of the page,
            if ( derivedHtIsLessThanWidth || paperHtIsLessThanWidth && !(derivedHtIsLessThanWidth && paperHtIsLessThanWidth) ) { //if and only if

                //  switch the page width and height
                m.set({
                    width: o.paperHeight * 96,
                    height: o.paperWidth * 96
                }, {silent: true});

                bPageDimsChanged = true;
            }
        }

        /**
         * Expand the size of the paper, if the derived text size doesn't fit
         * TODO: will also need to ceil the height / width in scale calcs ( the paper and the text should differ here ) ... still ?
         * Note: this page type doesn't support rotation so width is ok, not rotated width
         */

        if ( derivedWidthIncludingOffset * 96 > m.get('width') ) {
            m.set('width', derivedWidthIncludingOffset * 96 , {silent: true} );
            bPageDimsChanged = true;
        }

        // TODO - don't include whitespace (linebreak ) in the last line in the size calc,
        // it doesn't look like that should be included in the derived height ( still ?)
        if ( derivedHeightIncludingOffset * 96 > m.get('height') ) {
            m.set('height', derivedHeightIncludingOffset * 96, {silent: true} );
            bPageDimsChanged = true;
        }

        return bPageDimsChanged;

    },

    /* Set on model parse -- though now can change in _adjustPageDimsBasedOnActualTextDims
     * ( and the actual height and width set by the image size on load ... unsure if still applicable ... )
     * *** TODO: removal of necessary arguments, they aren't always called now ... I think can take out ***
     * Note: page type doesn't support rotation so don't need to take rotated height and width into account
     */
    updateViewPort: function( scale, prevScale ) {

        scale = this.scale.getScaleValue();

        prevScale = this.scale.previous('scale'); // TODO: still necessary for canvas???

        var model = this.model,
            pgW = model.get('width'),
            pgH = model.get('height'),
            scaledWt = pgW * scale,
            scaledHt = pgH * scale,
            pgCh = this.pgCanvasChannel;


        // The text in the overlay view
        // ensure the text is scaled first prior to the comparison -- unsure if still necessary --
        // This would change with the transform
        this.trigger( 'scaleColdText', scale, this.showGreenbar );

        // The paper -- el is the paper ( it's a text page )
        this.$el.css({
            width: scaledWt,
            height: scaledHt
        });

        /* **/
        /**
         * -- The image overlay --
         * DVBC- 980 -- IN SCALE PG (BASE) WHEN ADD this.ui.transformedWr to scale, don't need anymore -- so took out
         * DVBC-1004 - need to put back
         * DVBC-1821 -- need to include the height
         */

         if ( this.hasImageOverlay ) {

             // If there was a load error, there will be no image el to adjust ...
             if ( !this.model.get('loadError') ) {

                 this.imgView.$el.css({
                     width: this.imgActualDims.width * scale,
                     height: this.imgActualDims.height * scale
                 });
             }
         }

        /**
         * This must have been for the canvas.
         * Clean up when refactor this whole mess.
         * See pagePageMode.updateViewPort ( this.canvas && this.scaleCanvas.apply(this, arguments); )
         */

        if ( pgCh ) {
            // Here passing the page model as minor perf gain and flag
            pgCh.command('updateScale', scale, prevScale, {
                pageModel: model,
                updateCanvasOverlay: true
            });
        }
    },

    onActiveNoteChange: function(note) {

        PgModeImgWr.prototype.onActiveNoteChange.apply(this, arguments);

        /* toggle disabled 'text selection' menu item if the note is drawable */
        var entering = note !== null;

        // enable/disable the menu item allowing user to toggle text selection
        // (when disable, its also made 'inactive')
        this.pageDDView.triggerMethod('canvasEditModeToggled', entering);

        //on exit, always get out of selectTextMode, which no longer applies (may want to change this; no grabby hand or shape hovers by default)
        if ( !entering ) {
            this.selectTextMode = 0;
            this.$el.removeClass('canvas-edit-mode-select-text');
        }

    },

    onDestroy: function() {

        this.wasDestroyed = 1;
        this.textOverlay && this.textOverlay.destroy();

        this.remove();

    }

});




/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/page/overlay/pgModeOverlay/coldPageMode.js
 ** module id = 466
 ** module chunks = 0
 **/